import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync, TS_ErrorBoundary } from '@nu-art/thunderstorm-frontend/index';
import { BadImplementationException } from '@nu-art/ts-common';
class PgDev_ErrorBoundary_Class extends ComponentSync {
    deriveStateFromProps(nextProps) {
        return;
    }
    render() {
        return _jsx(TS_ErrorBoundary, { children: _jsx(Renderer, {}) });
    }
}
const Renderer = () => {
    throw new BadImplementationException('This is an error');
    return _jsx("div", {});
};
export const PgDev_ErrorBoundary = { name: 'Error Boundary', key: 'error-boundary', renderer: PgDev_ErrorBoundary_Class };
